<script>
import MembershipItem from './MembershipItem.vue';

export default {
  components: { MembershipItem },
  name: 'MembershipsList',
  props: {
    total: {
      type: Number,
      required: true,
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
    hasTitle: {
      type: Boolean,
      default: true,
    },
    hasPrice: {
      type: Boolean,
      default: true,
    },
    memberships: {
      type: Array,
      required: true,
    },
  },

  i18n: {
    messages: {
      en: {
        membership_plans: 'Subscription Plans',
        no_memberships_yet: 'There are no memberships yet!',
        no_memberships_match_search: 'No memberships match your search.',
      },
      fr: {
        membership_plans: 'Plans d\'abonnement',
        no_memberships_yet: 'Il n\'y a pas encore d\'abonnements !',
        no_memberships_match_search: 'Aucun abonnement ne correspond à votre recherche.',
      },
    },
  },
};
</script>

<template>
  <section>
    <h2 v-if="hasTitle" class="title is-custom is-size-5-touch">
      {{ $t('membership_plans') }}
    </h2>
    <p v-if="total <= 0" class="box">
      {{ $t('no_memberships_yet') }}
    </p>
    <template v-else-if="memberships.length">
      <MembershipItem v-for="membership in memberships" :key="membership.uuid" v-bind="{ membership, hasPrice }"
        :class="{ 'is-small': isSmall }" />
    </template>
    <p v-else class="box">
      {{ $t('no_memberships_match_search') }}
    </p>
  </section>
</template>
